import { FC, useLayoutEffect } from 'react'
import { Navigate, RouteObject, useRoutes } from 'react-router-dom'
import App from '../App'

// Public
import AuthLayout from '../layouts/auth/AuthLayout'
import { LayoutLogged } from '../layouts/LayoutLogged'
import { LayoutNotLogged } from '../layouts/LayoutNotLogged'
import HandleMagicLink from '../pages/auth/HandleMagicLink'
import LoginPage from '../pages/auth/Login'
import CampaignPage from '../pages/CampaignPage'
import HomePage from '../pages/HomePage'
import DataPrivacy from '../pages/legal/DataPrivacy'
import LegalNotice from '../pages/legal/LegalNotice'
import PastCampaignsPage from '../pages/PastCampaignsPage'

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        element: <LayoutNotLogged />,
        children: [
          {
            element: <AuthLayout />,
            children: [
              {
                path: 'auth/login',
                element: <LoginPage />,
              },
            ],
          },
          {
            path: 'auth/magic-link/handle',
            element: <HandleMagicLink />,
          },
        ],
      },
      {
        element: <LayoutLogged />,
        children: [
          {
            path: '/home',
            element: <HomePage />,
          },
          {
            path: '/campaigns/past',
            element: <PastCampaignsPage />,
          },
          {
            path: '/campaigns/:campaignEmployeeId',
            element: <CampaignPage />,
          },
          {
            path: '/legal-notice',
            element: <LegalNotice />,
          },
          {
            path: '/data-privacy',
            element: <DataPrivacy />,
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/auth/login" />,
      },
    ],
  },
]

const AppRoutes: FC = () => { 
  const routing = useRoutes(routes) 
 
  useLayoutEffect(() => { 
    // Scroll to top on route change 
    window.scrollTo(0, 0) 
  }, [location.pathname]) 
 
  return <>{routing}</> 
} 

export default AppRoutes
